export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'manage',
    subject: 'admin',
  },
  {
    action: 'manage',
    subject: 'coordinador',
  },
  {
    action: 'manage',
    subject: 'CoordinadorSubject',
  },
  {
    action: 'read',
    subject: 'reports',
  },
]

export const _ = undefined
